<script setup lang="ts">
import type { PlpHeroProps } from './PlpHero.props'

defineProps<PlpHeroProps>()

const { deferredTransparencyState } = useDefaultHeaderConfig()
</script>

<template>
  <div
    id="plp-hero"
    class="bg-neutral-light relative"
    :class="
      deferredTransparencyState.active
        ? 'editorial-hero-banner-header-transparent'
        : 'editorial-hero-banner'
    "
  >
    <NuxtPicture
      v-if="image?.media?.type === 'image'"
      provider="cloudinary"
      class="h-auto w-full object-cover"
      :src="image.media.srcImage?.public_id"
      :alt="image.media.alt"
      :img-attrs="{
        class: 'lg:h-full lg:object-cover lg:object-top lg:w-full',
      }"
      sizes="sm:100vw lg:80vw"
    />
    <div class="absolute inset-0 flex flex-col items-center justify-center">
      <p v-if="subtitle" class="text-medium-6 !font-light">
        {{ subtitle }}
      </p>
      <h1 class="text-medium-3 !font-light">
        {{ categoryName }}
      </h1>
    </div>
  </div>
</template>
<style scoped lang="scss">
.editorial-hero-banner-header-transparent {
  @screen lg {
    height: calc(95svh - (var(--marketing-strip-height)));
  }
}
.editorial-hero-banner {
  @screen lg {
    height: calc(
      95svh - (var(--marketing-strip-height) + var(--header-logo-bar-height))
    );
  }
}
</style>
